import { render, staticRenderFns } from "./XlButton.vue?vue&type=template&id=c6bfff46&scoped=true"
import script from "./XlButton.vue?vue&type=script&lang=js"
export * from "./XlButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bfff46",
  null
  
)

export default component.exports